import LoadService from 'services/load-service';

var courseSettings;
var CourseSettingsService = function() {
  if(CourseSettingsService.prototype._singleton) {
    return CourseSettingsService.prototype._singleton;
  }

  CourseSettingsService.prototype._singleton = this;

  this.files = {
    courseSettings: './content/course-settings.json'
  };
  this.initialize = function(settings) {
    return LoadService.load(this.files).then(function (data) {
      var course = data.courseSettings;
      if(settings.env && course[settings.env]) {
        course = _.extend(course, course[settings.env]);
      }
      course = _.extend(course, settings);
      if (settings.available_languages) {
        const availableFallbackLanguages = course.supported_languages.filter(
          lang => lang.length === 2
          );
          course.supported_languages = _.uniq(
            settings.available_languages.reduce((langs, lang) => {
              if (course.supported_languages.includes(lang)) {
                langs.push(lang);
              } else if (availableFallbackLanguages.includes(lang.substring(0, 2))) {
                langs.push(lang.substring(0, 2));
              }
              return langs;
            }, [])
          );
        course.supported_languages.sort();
      }
      courseSettings = new Chaplin.Model(course);
    });
  };

  this.get = function(key) {
    return courseSettings.get(key);
  };

  this.getModel = function() {
    return courseSettings;
  };
};

module.exports = new CourseSettingsService();
